import services from 'services/module';
import {tapfiliateLib} from '../lazy_modules';
import {LocalStorageSvc} from './LocalStorageSvc';
import {HttpSvcFactory} from './HttpSvc';
import {Utils} from '../underscore-extensions';

export class AffiliateSvc {
    private tapId              = options.isProduction ? '4142-17375a' : '4717-bb729d';
    private storageName        = 'anm_referrral_program';
    private storageValue       = this.LocalStorageSvc.get(this.storageName);
    private getReferralRequest = () => this.HttpSvc(`referral/foruser?product=${Utils.getProduct()}`);

    constructor(private $location: ng.ILocationService,
                private $q: ng.IQService,
                private LocalStorageSvc: LocalStorageSvc,
                private HttpSvc: HttpSvcFactory) {
    }

    isAffiliate() {
        const {tap_a} = this.$location.search() as anm.AffiliateParams;
        return !!tap_a;
    }

    init() {
        this.isAffiliate() && this.detectTap();
    }

    getAffiliateInfo() {
        const request = this.getReferralRequest();
        return this.loadLib()
            .then(() => request.secureGet())
            .then(r => r.data)
            .then((affiliateInfo: ApiError | anm.AffiliateInfo) => {
                return Utils.isApiError(affiliateInfo) ? this.updateReferralForUser() : affiliateInfo;
            });
    }

    private loadLib() {
        const deferred = this.$q.defer();
        loadScripts([tapfiliateLib], () => deferred.resolve());
        return deferred.promise;
    }

    private detectTap() {
        const programName = 'tap';

        this.loadLib().then(() => {
            window.tap.create(this.tapId);
            window.tap.detectClick();
            this.LocalStorageSvc.set(this.storageName, programName);
            this.storageValue = programName;
        });
    }

    private updateReferralForUser() {
        if (!this.storageValue) return this.$q.reject();

        return this.getPaymentInfo()
            .then((paymentInfo: {id: number, program_id: string}) => {
                const referralInfo = {
                        providerId: this.storageValue,
                        programId: paymentInfo.program_id,
                        paymentInfo: paymentInfo.id
                    };
                return this.getReferralRequest().securePut(referralInfo);
            })
            .then(r => r.data)
            .then((res: ApiError | anm.AffiliateInfo) => {
                return Utils.isApiError(res) ? this.$q.reject() : res;
            });
    }

    private getPaymentInfo() {
        const deferred = this.$q.defer();

        window.tap.create(this.tapId);
        window.tap && window.tap.conversion(
            `CUST_${options.user.userId}`,
            0, null, null,
            deferred.resolve.bind(deferred)
        );

        return deferred.promise;
    }
}

services.service('affiliateSvc', AffiliateSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/AffiliateSvc.ts